import { render, staticRenderFns } from "./OrderBoxStatus.vue?vue&type=template&id=799f630f&scoped=true"
var script = {}
import style0 from "./OrderBoxStatus.vue?vue&type=style&index=0&id=799f630f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f630f",
  null
  
)

export default component.exports